export const isStrExistHost = (str: string) => location.host.includes(str); // 验证host
export const isStrExisPathname = (reg: RegExp) => reg.test(location.pathname); // 验证pathname
